import { createSlice } from "@reduxjs/toolkit";
import getMeristemDefaultValue from "@utils/meristemContext/meristemContextDefaults";

const languageSlice = createSlice({
  name: "language",
  initialState: getMeristemDefaultValue().language_code,
  reducers: {
    setLanguage(state, action) {
      return action.payload || state;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
